var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOriLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "32px",
    viewBox: "0 0 78 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-View",
    transform: "translate(-129.000000, -432.000000)",
    fill: "#131316"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.44159,432 C154.143334,432.067969 161.177485,439.203712 161.177485,448 C161.177485,456.795242 154.143334,463.932031 145.44159,464 L145.44159,464 Z M144.705839,432 L144.705839,463.998954 C136.016532,463.9153 129,456.785831 129,448 C129,439.214169 136.016532,432.0847 144.705839,432 L144.705839,432 Z M177.179842,450.717208 L190.26355,463.917914 L164.097171,463.917914 L177.179842,450.717208 Z M192.335344,449.287027 L206.763283,463.842938 L192.335344,463.842938 L192.335344,449.287027 Z M163.535537,436.95748 L176.655519,450.194785 L163.535537,463.432089 L163.535537,436.95748 Z M207,433.544683 L207,462.99217 L192.407271,448.267904 L207,433.544683 Z M164.049288,436.407764 C169.612766,431.007856 178.461681,431.070597 183.945354,436.603307 C189.429028,442.136017 189.491213,451.06197 184.1402,456.677289 L184.1402,456.677289 Z M206.766185,432.707718 L192.336173,447.267813 L192.336173,432.707718 L206.766185,432.707718 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriLogo);
export default __webpack_public_path__ + "static/media/ori_logo.0e0840a28cc1c305fbdce7faae4f2ead.svg";
export { ForwardRef as ReactComponent };